export default function({ paymentSystem, paymentSystemMaster}) {
  return URL.createObjectURL(new Blob([`
    <html>
      <head>
        <meta name="card-type" content="">
        <meta name="payment-token" content="">
        <meta name="end-loading" content="">
        <link rel="stylesheet" href="${process.env.VUE_APP_URL}iframe_resources/payment_method/index.css">
        <script type="text/javascript" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/jquery-3.6.0.min.js"></script>
        <script type="text/javascript" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/jquery.creditCardValidator.js"></script>
        <script type="text/javascript" src="https://credit.j-payment.co.jp/gateway/js/CPToken.js"></script>
        <script type="text/javascript" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/index.js"></script>
        <script>
          let validator

          $(function() {
            validator = new PaymentFormValidator()
          })

          function endInnerLoading() {
            $("meta[name ='end-loading']").attr('content', true)
          }

          function doPurchase() {
            $('#formInvalidMessage').removeClass('active')
            $('#formInvalidMessage').text('')

            const validate = validator.validate()
            if (validate) {
              const ed = $("#ed").val().replace(/[^0-9]+/i, '')
              CPToken.TokenCreate({
                aid: '${paymentSystemMaster.shopCode}',
                cn: $("#cn").val(),
                cvv: $("#cvv").val(),
                ed: ed.slice(2, 4) + ed.slice(0, 2),
                fn: $("#fn").val(),
                ln: $("#ln").val()
              }, execPurchase)
            } else {
              endInnerLoading()
            }
          }

          function execPurchase(resultCode, errMsg) {
            if (resultCode == 'Success') {
              $("meta[name ='payment-token']").attr('content', $('#tkn').val())
            } else {
              $('#formInvalidMessage').addClass('active')
              $('#formInvalidMessage').text(errMsg)
            }
            endInnerLoading()
          }
        </script>
      </head>
      <body>
        <div id="ccImages" class="cc-images-wrapper">
          <img name="cc-visa" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/cc_visa.png">
          <img name="cc-mastercard" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/cc_mastercard.png">
          <img name="cc-jcb" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/cc_jcb.png">
          <img name="cc-amex" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/cc_amex.png">
          <img name="cc-diners" src="${process.env.VUE_APP_URL}iframe_resources/payment_method/cc_diners.png">
        </div>
        <form id="mainform">
          <div class="input-group">
            <label>カード番号（最大16桁）</label>
            <input type="text" value="" name="cn" id="cn" maxlength="16" placeholder="0000 0000 0000 0000" />
            <span class="invalid-message"></span>
          </div>
          <div class="input-group-wrapper">
            <div class="input-group">
              <label>カード有効期限（月 / 年）</label>
              <input type="text" value="" name="ed" id="ed" placeholder="MM / YY" maxlength="7" />
              <span class="invalid-message"></span>
            </div>
            <div class="input-group">
              <label>セキュリティーコード CVV/CVC</label>
              <input type="text" value="" name="cvv" id="cvv" maxlength="4" />
              <span class="invalid-message"></span>
            </div>
          </div>
          <div class="input-group-wrapper">
            <div class="input-group">
              <label>カード名義人（半角英字）</label>
              <input type="text" value="" name="fn" id="fn" placeholder="TARO（名）"/>
              <span class="invalid-message"></span>
            </div>
            <div class="input-group">
              <label></label>
              <input type="text" value="" name="ln" id="ln" placeholder="IWATSU（姓）"/>
              <span class="invalid-message"></span>
            </div>
          </div>
          <div class="input-group">
            <label>お支払い用メールアドレス</label>
            <input type="email" value="${paymentSystem.paymentEmail ?? ''}" name="email" id="email" />
            <span class="invalid-message"></span>
          </div>
          <div class="input-group">
            <label>お支払い用電話番号（ハイフンなし）</label>
            <input type="text" value="${paymentSystem.paymentPhone ?? ''}" name="phoneNumber" id="phoneNumber" maxlength="11" />
            <span class="invalid-message"></span>
          </div>
          <input id="tkn" name="tkn" type="hidden" value="">
          <input id="doPurchaseButton" type="button" value="登録する" onclick="doPurchase()"/>
          <div id="formInvalidMessage" class="form-invalid-message"></div>
        </form>
      </body>
    </html>
  `], { type: 'text/html' }))
}
